export const getIconRender = ({ iconName, iconKeyPrefix, iconIndex, defaultIcon }) => {
  if (iconName?.startsWith("mdi-")) {
    // Material Design Icons (Web Fonts)
    return <span className={`mdi ${iconName}`} key={`${iconKeyPrefix}-${iconIndex}`}></span>
  } else if (iconName?.startsWith("mi-")) {
    // Google Material Icons
    const strippedIconName = iconName.slice(3)
    return (
      <span className="material-icons" key={`${iconKeyPrefix}-${iconIndex}`}>
        {strippedIconName}
      </span>
    )
  } else if (iconName?.includes(",")) {
    // Extract Font Awesome tags (assume first item is font awesome class string)
    const faTags = iconName.split(",")
    const faClass = faTags?.[0]
    const faClasses =
      faClass +
      " " +
      faTags
        .slice(1)
        .map((tag) => `fa-${tag}`)
        ?.join(" ")
    return <i className={faClasses} key={`${iconKeyPrefix}-${iconIndex}`}></i>
  } else if (iconName) {
    return <i className={`fas fa-${iconName}`} key={`${iconKeyPrefix}-${iconIndex}`}></i>
  } else if (defaultIcon) {
    return getIconRender({ iconName: defaultIcon, iconKeyPrefix, iconIndex })
  }
}
